// src/components/SEO.js
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, url, image }) => {
    const webAppSchema = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Chatlea",
        "description": description || "Free video chat with strangers worldwide. No sign-up required.",
        "url": url || "https://chatlea.com",
        "applicationCategory": "Communication",
        "operatingSystem": "Web Browser",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
        }
    };

    // FAQ Schema (Add your top 3-5 questions)
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Is Chatlea really free?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Chatlea offers 100% free video calls with no hidden charges or registration required."
                }
            },
            {
                "@type": "Question",
                "name": "How does Chatlea protect my privacy?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We use end-to-end encryption and never store your video chats or personal data."
                }
            },
            {
                "@type": "Question",
                "name": "Can I use Chatlea without signing up?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! Chatlea works instantly with no account needed - just click and start chatting."
                }
            }
        ]
    };
    return (
        <Helmet>
            {/* Standard meta tags */}
            <title>{title || "Free Video Chat with Strangers | VideoChat"}</title>
            <meta name="description" content={description || "Instant anonymous video chat with no registration."} />

            {/* OpenGraph (Facebook/LinkedIn) */}
            <meta property="og:title" content={title || "Free Video Chat with Strangers | VideoChat"} />
            <meta property="og:description" content={description || "Instant anonymous video chat with no registration."} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || "https://chatlea.com"} />
            <meta property="og:image" content={image || "https://chatlea.com/logo.png"} />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title || "Free Video Chat with Strangers | VideoChat"} />
            <meta name="twitter:description" content={description || "Instant anonymous video chat with no registration."} />
            <meta name="twitter:image" content={image || "https://chatlea.com/logo.png"} />

            {/* JSON-LD Schema */}
            <script type="application/ld+json">
                {JSON.stringify(webAppSchema)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
            </script>
        </Helmet>
    );
};

export default SEO;